import { render } from "./LlmEmailSkillAssessment.vue?vue&type=template&id=641043ab"
import script from "./LlmEmailSkillAssessment.vue?vue&type=script&lang=js"
export * from "./LlmEmailSkillAssessment.vue?vue&type=script&lang=js"

import "./LlmEmailSkillAssessment.vue?vue&type=style&index=0&id=641043ab&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__